/**
 * Onboarding & Tutorial Translations (TR/EN)
 */

import { Translations } from '../shared/i18n';

export const onboardingTranslations: Translations = {
    tr: {
        // Wizard
        onboardingWelcomeTitle: 'Hoş Geldiniz!',
        onboardingWelcomeDesc: 'Harcamalarınızı kolayca yönetmek için birkaç adımda başlayalım.',
        onboardingLetsStart: 'Başlayalım',

        onboardingThemeTitle: 'Tema Seçin',
        onboardingThemeDesc: 'Arayüzünüzü nasıl görmek istersiniz?',
        onboardingThemeLight: 'Açık',
        onboardingThemeDark: 'Koyu',
        onboardingThemeSystem: 'Sistem',
        onboardingThemeLightDesc: 'Klasik beyaz arayüz',
        onboardingThemeDarkDesc: 'Göz yormayan koyu arayüz',
        onboardingThemeSystemDesc: 'Cihaz ayarını takip et',

        onboardingLangTitle: 'Dil Seçin',
        onboardingLangDesc: 'Uygulamayı hangi dilde kullanmak istersiniz?',
        onboardingLangTR: 'Türkçe',
        onboardingLangEN: 'İngilizce',
        onboardingLangDE: 'Almanca',

        onboardingCurrencyTitle: 'Para Birimi Seçin',
        onboardingCurrencyDesc: 'Tutarlar varsayılan olarak hangi para biriminde gösterilsin?',
        onboardingCurrencyEUR: 'Euro',
        onboardingCurrencyUSD: 'ABD Doları',
        onboardingCurrencyCHF: 'İsviçre Frangı',
        onboardingCurrencyHint: 'Bu ayarı daha sonra Ayarlar > Görünüm sayfasından değiştirebilirsiniz.',

        onboardingReadyTitle: 'Hazırsınız!',
        onboardingReadyDesc: 'Uygulamayı keşfetmeniz için kısa bir tur hazırladık.',
        onboardingStartTour: 'Turu Başlat',
        onboardingSkipTour: 'Turu Atla',

        onboardingNext: 'İleri',
        onboardingBack: 'Geri',
        onboardingSkip: 'Atla',

        // Tutorial
        tutorialStepOf: 'Adım {current} / {total}',
    },
    en: {
        // Wizard
        onboardingWelcomeTitle: 'Welcome!',
        onboardingWelcomeDesc: "Let's get you set up in a few quick steps to manage your expenses easily.",
        onboardingLetsStart: "Let's Start",

        onboardingThemeTitle: 'Choose Theme',
        onboardingThemeDesc: 'How would you like your interface to look?',
        onboardingThemeLight: 'Light',
        onboardingThemeDark: 'Dark',
        onboardingThemeSystem: 'System',
        onboardingThemeLightDesc: 'Classic white interface',
        onboardingThemeDarkDesc: 'Easy on the eyes dark interface',
        onboardingThemeSystemDesc: 'Follow device setting',

        onboardingLangTitle: 'Choose Language',
        onboardingLangDesc: 'Which language would you like to use?',
        onboardingLangTR: 'Turkish',
        onboardingLangEN: 'English',
        onboardingLangDE: 'German',

        onboardingCurrencyTitle: 'Choose Currency',
        onboardingCurrencyDesc: 'Which currency should amounts be displayed in by default?',
        onboardingCurrencyEUR: 'Euro',
        onboardingCurrencyUSD: 'US Dollar',
        onboardingCurrencyCHF: 'Swiss Franc',
        onboardingCurrencyHint: 'You can change this later in Settings > Display.',

        onboardingReadyTitle: "You're All Set!",
        onboardingReadyDesc: "We've prepared a quick tour to help you explore the app.",
        onboardingStartTour: 'Start Tour',
        onboardingSkipTour: 'Skip Tour',

        onboardingNext: 'Next',
        onboardingBack: 'Back',
        onboardingSkip: 'Skip',

        // Tutorial
        tutorialStepOf: 'Step {current} of {total}',
    },
    de: {
        // Wizard
        onboardingWelcomeTitle: 'Willkommen!',
        onboardingWelcomeDesc: 'Lassen Sie uns in wenigen Schritten einrichten, damit Sie Ihre Ausgaben einfach verwalten können.',
        onboardingLetsStart: 'Los geht\'s',

        onboardingThemeTitle: 'Design wählen',
        onboardingThemeDesc: 'Wie soll Ihre Oberfläche aussehen?',
        onboardingThemeLight: 'Hell',
        onboardingThemeDark: 'Dunkel',
        onboardingThemeSystem: 'System',
        onboardingThemeLightDesc: 'Klassische helle Oberfläche',
        onboardingThemeDarkDesc: 'Augenschonende dunkle Oberfläche',
        onboardingThemeSystemDesc: 'Geräteeinstellung übernehmen',

        onboardingLangTitle: 'Sprache wählen',
        onboardingLangDesc: 'In welcher Sprache möchten Sie die App nutzen?',
        onboardingLangTR: 'Türkisch',
        onboardingLangEN: 'Englisch',
        onboardingLangDE: 'Deutsch',

        onboardingCurrencyTitle: 'Währung wählen',
        onboardingCurrencyDesc: 'In welcher Währung sollen Beträge standardmäßig angezeigt werden?',
        onboardingCurrencyEUR: 'Euro',
        onboardingCurrencyUSD: 'US-Dollar',
        onboardingCurrencyCHF: 'Schweizer Franken',
        onboardingCurrencyHint: 'Sie können dies später unter Einstellungen > Anzeige ändern.',

        onboardingReadyTitle: 'Alles bereit!',
        onboardingReadyDesc: 'Wir haben eine kurze Tour vorbereitet, um Ihnen die App zu zeigen.',
        onboardingStartTour: 'Tour starten',
        onboardingSkipTour: 'Tour überspringen',

        onboardingNext: 'Weiter',
        onboardingBack: 'Zurück',
        onboardingSkip: 'Überspringen',

        // Tutorial
        tutorialStepOf: 'Schritt {current} von {total}',
    },
};
